import { useEffect } from 'react';

import { useSnackbar } from '@/contexts/SnackbarContext';

import { appNotifier } from './notifier';

/**
 * Connects the sagas' notifier to the snackbar (#743). Renders nothing; mount
 * it once, inside `SnackbarProvider`.
 */
export default function NotifierBridge() {
  const { notifyError } = useSnackbar();
  useEffect(() => appNotifier.connect({ error: notifyError }), [notifyError]);
  return null;
}
